import * as React from 'react'
import APageHeader from '../../components/atoms/APageHeader'
import PowerbiSettings from '../../containers/settings/PowerbiSettings'

class PPowerbiSettings extends React.Component {
    render() {
        return (
            <React.Fragment>
                <APageHeader>PowerBI settings</APageHeader>
                <PowerbiSettings />
            </React.Fragment>
        )
    }
}

export default PPowerbiSettings
